/**
 * 前台后台的「权限等级」工具
 * 登录时后端会把 role / roleLabel / pages / canDelete / canManageRole / isSuper 一起发下来，
 * 存在 vuex（localStorage 持久化）里，这里统一从 store 读。
 *
 * 说明：真正的边界在服务端（app.js 里对接口做了同样的校验），
 * 这里只负责「不给看的菜单不显示、没权限的删除按钮藏起来」。
 * 老登录态（改版之前登录的）没有 pages 字段 → 一律按有权限处理，免得把主人自己锁在外面。
 */
import store from '../store';

const info = () => store.state.userInfo || {};

/** 是不是超级管理员（数据库里 role = admin） */
export const isSuper = () => {
  const i = info();
  return Number(i.isSuper) === 1 || i.role === 'admin';
};

/** 后台改版前登录的旧会话：字段还没发下来 */
const legacySession = () => info().pages === undefined;

/** 能不能访问某个后台页面（参数是路由路径，例如 /admin/gift/list） */
export const canVisit = (path) => {
  const i = info();
  if (isSuper() || legacySession()) return true;
  const pages = Array.isArray(i.pages) ? i.pages : [];
  return pages.indexOf(path) >= 0;
};

/** 有没有删除权限 */
export const canDelete = () => {
  const i = info();
  if (isSuper() || legacySession()) return true;
  return Number(i.canDelete) === 1;
};

/** 能不能管权限等级本身 */
export const canManageRole = () => {
  const i = info();
  if (isSuper() || legacySession()) return true;
  return Number(i.canManageRole) === 1 || canVisit('/admin/user-manage/role');
};

export const roleLabel = () => info().roleLabel || info().role || '';
